import { useState } from 'react';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Activity, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) { toast.error('Inserisci username e password'); return; }
    setLoading(true);
    try {
      await login(username, password);
      toast.success('Accesso effettuato');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Credenziali non valide');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-bg min-h-screen flex items-center justify-center p-4" data-testid="login-page">
      <div className="glass-card rounded-2xl shadow-2xl w-full max-w-md p-8 animate-fade-in">
        <div className="flex items-center gap-3 mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_resident-health-hub/artifacts/scmtxjkj_IMG_0881.jpeg"
            alt="Santa Maria Valleverde"
            className="w-14 h-14 rounded-xl object-cover shadow-lg"
          />
          <div>
            <h1 className="text-xl font-bold text-slate-900 font-[Cinzel] tracking-tight leading-tight">Santa Maria Valleverde</h1>
            <p className="text-xs text-slate-500">Residenza Socio-Assistenziale Protetta</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="username" className="text-sm font-medium text-slate-700">Username</Label>
            <Input
              id="username"
              data-testid="login-username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="es. coordinatore"
              className="h-11"
              autoComplete="username"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password" className="text-sm font-medium text-slate-700">Password</Label>
            <div className="relative">
              <Input
                id="password"
                data-testid="login-password"
                type={showPw ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Inserisci password"
                className="h-11 pr-10"
                autoComplete="current-password"
              />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600">
                {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          <Button type="submit" data-testid="login-submit" className="w-full h-11 bg-brand hover:bg-brand-dark text-white font-semibold" disabled={loading}>
            {loading ? 'Accesso in corso...' : 'Accedi'}
          </Button>
        </form>

        <p className="text-xs text-slate-400 text-center mt-6">Santa Maria Valleverde S.r.l.</p>
      </div>
    </div>
  );
}
